import { apiGet, apiPatch, apiPost } from '../client';
import {
  AgentsResponseSchema,
  ProposalResponseSchema,
  type AgentsBoard,
  type Proposal,
  type ProposalDraft,
} from '../agentSchemas';

/** The team, what each one is doing, and what waits for the owner. Ultra only. */
export async function getAgentsBoard(): Promise<AgentsBoard> {
  const response = await apiGet('/v1/business/agents', AgentsResponseSchema);
  return response.data;
}

function proposalPath(proposalId: string, action?: 'approve' | 'dismiss'): string {
  const base = `/v1/business/agents/proposals/${encodeURIComponent(proposalId)}`;
  return action ? `${base}/${action}` : base;
}

export async function editProposal(
  proposalId: string,
  input: { expectedVersion: number; draft: ProposalDraft },
  idempotencyKey: string,
): Promise<Proposal> {
  const response = await apiPatch(proposalPath(proposalId), ProposalResponseSchema, input, idempotencyKey);
  return response.data;
}

export async function approveProposal(
  proposalId: string,
  expectedVersion: number,
  idempotencyKey: string,
): Promise<Proposal> {
  const response = await apiPost(proposalPath(proposalId, 'approve'), ProposalResponseSchema, { expectedVersion }, idempotencyKey);
  return response.data;
}

export async function dismissProposal(
  proposalId: string,
  expectedVersion: number,
  idempotencyKey: string,
): Promise<Proposal> {
  const response = await apiPost(proposalPath(proposalId, 'dismiss'), ProposalResponseSchema, { expectedVersion }, idempotencyKey);
  return response.data;
}
